// extracted by mini-css-extract-plugin
export var root = "OrderSummary-module--root--a1835";
export var orderSummary = "OrderSummary-module--orderSummary--2151a";
export var actionContainer = "OrderSummary-module--actionContainer--69686";
export var calculationContainer = "OrderSummary-module--calculationContainer--0cca1";
export var labelContainer = "OrderSummary-module--labelContainer--bdd63";
export var title = "OrderSummary-module--title--ac4fb";
export var couponContainer = "OrderSummary-module--couponContainer--13bed";
export var totalContainer = "OrderSummary-module--totalContainer--491aa";
export var linkContainer = "OrderSummary-module--linkContainer--62772";